import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import type { CheckAccountApi, CheckAccountRes } from './check-account-api.interface';

@injectable()
export class CheckAccountApiImpl extends PsHttpService implements CheckAccountApi {
  get options() {
    const baseURL = (typeof import.meta !== 'undefined' && import.meta.env)
      ? import.meta.env.VITE_EUREKA_SERVICE_URI
      : process.env.VUE_APP_EUREKA_SERVICE_URI;
    return {
      baseURL: `${baseURL}/eureka`,
      headers: {
        'X-API-Version': '1.0',
      },
    };
  }

  checkAccount(email: string) {
    return this.get<PatSnapCommonResponseData<CheckAccountRes>>({
      url: '/user-phone',
      params: {
        email,
      },
    }).then((res) => {
      return res.data as CheckAccountRes;
    });
  }
}
